<template>
  <FormulaireRole />
</template>

<script>
import FormulaireRole from '@/components/roles/FormulaireRole.vue'

export default {
  name: 'CreateTypeUser',
  components: { FormulaireRole },
}
</script>
